import { Button } from "components/DesignSystem/Button/Button";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import CustomReportIcon from "components/icons/CustomReportIcon";
import OperatingExpenseIcon from "components/icons/OperatingExpenseIcon";
import ThreeDots from "static/images/ThreeDots.svg";
import type { CustomReport } from "store/apis/customReports";
import { stopPropagation } from "utils/stopPropagation";

export const ReportCard = ({
  report,
  onClick,
  onEdit,
  onDelete,
}: {
  report: CustomReport;
  onClick: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
}) => {
  const showMenu = !report.is_template && (onEdit || onDelete);

  return (
    <button
      type="button"
      className="all:unset t-box-border t-flex t-cursor-pointer t-items-center t-justify-between t-rounded-lg t-border t-border-solid t-border-neutral-10 t-p-4 sm:t-px-3 t-gap-3 t-transition-shadow hover:t-shadow-light-60"
      onClick={onClick}
    >
      <div className="t-flex t-items-center t-gap-3">
        <div className="t-flex t-items-center t-justify-center t-w-10 t-h-10 t-rounded-full t-bg-primary-5">
          <div className="t-flex t-items-center t-justify-center t-rounded-full t-shadow-[0_0_0_4px_rgba(111,79,191,0.06)]">
            {report.is_template ? (
              <OperatingExpenseIcon />
            ) : (
              <CustomReportIcon />
            )}
          </div>
        </div>

        <div className="t-flex t-flex-col t-gap-0.5">
          <span className="t-text-body-sm t-font-medium t-text-text-60">
            {report.title}
          </span>
        </div>
      </div>

      {showMenu && (
        <Dropdown.Root>
          <Dropdown.Trigger asChild>
            <div onClick={stopPropagation} role="presentation">
              <Button size="xsmall" customType="ghost_icon">
                <img src={ThreeDots} alt="Action" className="t-select-none" />
              </Button>
            </div>
          </Dropdown.Trigger>

          <Dropdown.Portal>
            <Dropdown.Content
              className="!t-w-40 !t-min-w-40"
              sideOffset={4}
              align="end"
              side="bottom"
              onClick={stopPropagation}
            >
              {onEdit && <Dropdown.Item onSelect={onEdit}>Edit</Dropdown.Item>}
              {onDelete && (
                <Dropdown.Item type="danger" onSelect={onDelete}>
                  Delete
                </Dropdown.Item>
              )}
            </Dropdown.Content>
          </Dropdown.Portal>
        </Dropdown.Root>
      )}
    </button>
  );
};
